import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import React from 'react';

const Mcq = ({ item, index, onChange }) => {
  const handleChange = (e) => {
    const value = e.target.value;
    if (onChange) {
      onChange(value);
    } else {
      item.answer = value;
    }
  };

  return (
    <div>
      <FormControl fullWidth component="fieldset" sx={{ marginLeft: '4px' }}>
        <RadioGroup
          aria-label={`question-${index}`}
          name={`question-${index}`}
          value={item.answer || ''}
          onChange={handleChange}>
          {item.options.map((option, optionIndex) => {
            return (
              <FormControlLabel
                key={optionIndex}
                value={option.text}
                control={<Radio />}
                label={option.text}
                sx={{
                  borderRadius: '5px',
                  margin: '0px'
                }}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default Mcq;
